import PropTypes from 'prop-types'

import { Circle } from '@phosphor-icons/react';
import { Typography, Box } from '@mui/material';

export function StatusIndicator({
  color,
  label
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}> 
      <Circle  weight="fill" color={`var(--${color})`} size={10} />
      <Typography sx={{ fontSize: 13, opacity: 0.7, fontWeight: 'bold' }}>{label}</Typography>
    </Box>
  )
}

StatusIndicator.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}

export default StatusIndicator